import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAutopilotStatusV1Response } from './get-autopilot-status-v1-response';
import { getAutopilotStatusV1ResponseSchema } from './get-autopilot-status-v1-response';

export async function getAutopilotStatusV1Api(): Promise<
  IValidatedResponse<IGetAutopilotStatusV1Response>
> {
  return getRequest<IGetAutopilotStatusV1Response>({
    path: '/sys/social/v1/autopilot/status',
    schema: getAutopilotStatusV1ResponseSchema,
  });
}
